import type { HelpFile } from '../../types/help'
import { RestrictionRulesTestIds } from '../../../testids/RestrictionRulesTestIds'

export const restrictionRulesHelp: HelpFile = {
  docPage: '/docs/access-governance/restriction-rules',
  texts: {
    [RestrictionRulesTestIds.restrictionRulesList]:
      'Alle im System definierten Restriktionsregeln — jede Regel benennt Zugriffsprofile, die nicht gleichzeitig auf derselben Identität vorhanden sein dürfen, und deckt damit Funktionstrennung und Interessenkonflikte ab.',
    [RestrictionRulesTestIds.btnDetectionHistory]:
      'Verlauf aller Erkennungsläufe: wann jede Regel ausgewertet wurde und welche Verstöße dabei festgestellt wurden.',
    [RestrictionRulesTestIds.colViolations]:
      'Anzahl der Identitäten, die diese Restriktionsregel aktuell verletzen.',
  },
}
